import type { InputSelectedPayload } from '../types';

export const sendInputSelectedEvent = async ({ label, value }: InputSelectedPayload) => {
  const { $mixpanel } = useNuxtApp();

  $mixpanel.track('input_selected', {
    eventProps: {
      label,
      value
    }
  });
};
